import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const opsApi = (token) => {
  const h = { headers: { "X-Admin-Token": token } };
  return {
    get: (p, params) => axios.get(`${API}${p}`, { ...h, params }).then((r) => r.data),
    post: (p, b) => axios.post(`${API}${p}`, b, h).then((r) => r.data),
    put: (p, b) => axios.put(`${API}${p}`, b, h).then((r) => r.data),
    del: (p) => axios.delete(`${API}${p}`, h).then((r) => r.data),
    // Opens an admin-only HTML page (report / signed record) in a new tab without exposing the token in a URL.
    openHtml: async (p, params) => {
      const w = window.open("", "_blank");
      const r = await axios.get(`${API}${p}`, { ...h, params, responseType: "text" });
      w.document.open(); w.document.write(r.data); w.document.close();
    },
    csv: async (p, params, name) => {
      const r = await axios.get(`${API}${p}`, { ...h, params, responseType: "blob" });
      const a = document.createElement("a"); a.href = URL.createObjectURL(r.data); a.download = name; a.click();
    },
  };
};

export const errMsg = (e) => { const d = e?.response?.data?.detail; return typeof d === "string" ? d : d?.message || "Something went wrong."; };
export const usd = (n) => `${Number(n || 0) < 0 ? "-" : ""}$${Math.abs(Number(n || 0)).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const KIND = { four_week: "Four-week", dropin: "Drop-in", trial: "Trial", lesson: "Private lesson", other: "Other" };
export const panel = "rounded-3xl bg-white text-[#0B0F19] p-5 md:p-7";
export const card = "rounded-2xl border border-slate-200 bg-white p-4";
export const btn = (on) => `rounded-full px-4 py-2 text-sm font-bold transition-colors ${on ? "bg-[#0B0F19] text-white" : "border border-slate-300 text-slate-600 hover:text-[#0B0F19]"}`;
export const field = "rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-sm text-[#0B0F19] outline-none focus:border-[#2563EB]";
export const dlong = (d) => new Date(`${d}T12:00:00Z`).toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric", timeZone: "UTC" });
